var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('item-form',{attrs:{"schema":"new","title":"NUEVO INCONVENIENTE","icon":"mdi-account-question-outline"}})}
var staticRenderFns = []

export { render, staticRenderFns }